import { colors } from '@constants/colors';
import { isMobileOnly } from 'react-device-detect';
import { ScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    root: {
      color: colors.white,
      background: '#0C0B0B66',
      borderRadius: '99px',
      backdropFilter: 'blur(40px)',
      py: 1,
      px: 2,
      fontSize: isMobileOnly ? 9 : 14,
      lineHeight: 1.35,
      display: 'flex',
      alignItems: 'center',
      gap: 0.5,
      marginLeft: isMobileOnly ? 'auto' : 'unset',

      '& svg': {
        fontSize: 16,
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: 9,
        marginLeft: 'auto',
      },
    },
  };
};
